module.exports = ".example-radio-group{display:flex;flex-direction:column;margin:15px 0}.example-radio-button{margin:5px}\n"